


































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { AIJobType, IBlueprint, ISurveyStep, BlueprintStep, isISurveyStep } from '@/store/types';
import AIBuildModal from '@/components/UI/AIBuildModal.vue';
import { AI_JOB_TYPES, STEP_TYPE, SAVE_STATE, LOAD_STATE } from '@/store/shared';
import { AI_CANCEL_JOB } from '@/store/action-types';
import { currentBlueprint } from '@/store/getters';

export default Vue.extend({
  name: 'AIReworkButton',
  components: {
    AIBuildModal,
  },
  props: {
    blueprintGuid: {
      type: String,
      default: '',
    },
    stepGuid: {
      type: String,
      default: '',
    },
    surveyChoiceGuid: {
      type: String,
      default: '',
    },
    onSubmit: {
      type: Function,
      default: () => {
        // do nothing
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    canCancel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showAIBuildModal: false,
      submitted: false,
      prompt: '',
      SAVE_STATE,
      LOAD_STATE,
    };
  },
  computed: {
    ...mapGetters(['primaryBlueprint', 'currentBlueprint', 'aiJobsInProgress', 'currentBlueprintSaveState']),
    stepMap(): { [key: string]: BlueprintStep } {
      return this.$store.getters.blueprintStepMap;
    },
    surveyStep(): ISurveyStep | null {
      const step: BlueprintStep = this.stepMap[STEP_TYPE.SURVEY];
      if (isISurveyStep(step)) {
        return step as ISurveyStep;
      }
      return null;
    },
    blueprint(): IBlueprint {
      return this.$store.getters.currentBlueprint;
    },
    generating(): boolean {
      return this.$props.loading || this.submitted;
    },
    reworkType(): AIJobType {
      if (this.$props.stepGuid) return AI_JOB_TYPES.REWORK_STEP;
      if (this.$props.surveyChoiceGuid) return AI_JOB_TYPES.REWORK_SURVEY_CHOICE;
      return AI_JOB_TYPES.REWORK_BLUEPRINT;
    },
  },
  methods: {
    closeAIBuildModal() {
      this.$data.showAIBuildModal = false;
    },
    cancelAIJob() {
      // dispatch action to cancel job
      this.$store.dispatch(AI_CANCEL_JOB, {
        stepGuid: this.$props.stepGuid,
        surveyChoiceGuid: this.$props.surveyChoiceGuid,
        blueprintGuid: this.$props.blueprintGuid,
      });
    },
    /*
    async onAISubmit() {
      this.$emit('rework');
    },
    */
  },
});
